import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { PrimeiroContato } from "../models/primeiro-contato.model";

@Injectable()
export class PrimeiroContatoService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Primeiro Contato com Cliente por id
     * @param id ID da Primeiro Contato com Cliente
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "primeiro-contato-cliente/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Primeiro Contato com Cliente
     * @param id ID da Primeiro Contato com Cliente
     */
    getAll(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "primeiro-contato-cliente" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Primeiro Contato Para Campo de cadastro do cliente
     */
    getLista(): Observable<ApiPaginationResponseDataNonNullable<PrimeiroContato>> {
        return this._http.get<ApiPaginationResponseDataNonNullable<PrimeiroContato>>(
            this.utilitesService.urlPrefix + "primeiro-contato-cliente/lista",
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Delete de Primeiro Contato com Cliente
     * @param id ID da Primeiro Contato com Cliente
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "primeiro-contato-cliente/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Primeiro Contato com Cliente
     * @param params Json Primeiro Contato com Cliente
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "primeiro-contato-cliente", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Primeiro Contato com Cliente
     * @param params Json Primeiro Contato com Cliente
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "primeiro-contato-cliente/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
